<div class="rcl-row rcl-guest-selector-list-row">
	<div class="rcl-col-sm-12 rcl-guest-list">
	    @for (guest of guestsNotCompleted; track guest.guestId) {
			<rcg-item-selector
			class="rcl-col-sm-12 rcl-col-md-6"
			[brand]="brandName"
			[disabled]="guest.isLocked"
			[data]="getDataForItemSelector(guest)"
			[name]="'guest' + guest.guestId"
			[id]="guest.guestId"
			(dataSelected)="selectGuest($event, guest.guestId)"
			[attr.aria-label]="guest.isLocked ? guest.firstName + ' ' + getGuestLastName(guest) + ' is unavailable for check-in.' : ''"
			></rcg-item-selector>
	    }
	</div>
</div>